import { createSelector } from 'reselect';
import { FormControlErrors, FormErrors, FormState } from 'ia-react-core/~/interfaces/FormState';
import keys from 'ia-react-core/~/utils/accessors/keys';

import get from '../../utils/accessors/get';

const isValidSelector = () => createSelector(
  (formState: FormState) => get(formState, 'errors'),
  (errors: FormErrors) => !hasErrors(errors),
);

function hasErrors(errors: FormErrors | FormControlErrors): boolean {
  return keys(errors).some((key) => {
    const keyValue = errors[key];
    if (typeof keyValue === 'object') {
      return hasErrors(keyValue);
    }

    return keyValue;
  });
}

/**
 * @component
 * @visibleName isValidSelector
 */
export default isValidSelector;
